import React from "react";

const SizeSelector = ({ sizes }) => {
  const isAvailable = (size) => {
    return size.availability !== "false" && size.availability !== false && size.available !== false;
  };

  return (
    <div className="flex gap-2 mt-3 justify-start">
      {sizes.map((size, index) => (
        <div
          key={index}
          className="p-4 flex items-center justify-center cursor-default bg-[#ECF7F8] opacity-100 rounded-xl"
          style={
            !isAvailable(size)
              ? {
                  textDecorationLine: "line-through",
                  textDecorationColor: "red",
                  textDecorationThickness: "3px",
                  cursor: "not-allowed",
                  opacity: 0.5,
                }
              : {}
          }
        >
          <span className="text-xs text-black font-semibold opacity-100">
            {size.size}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SizeSelector;
